<template>
  <!-- Used for US and Canada toggle -->
  <div class="toggleSwitch">
    <div class="toggle" v-for="(label, index) in toggles" :key="label">
      <input
        :type="type"
        :name="inputName"
        :id="inputName + index"
        :checked="isChecked(label)"
        @change="inputChanged($event, label)"
        :disabled="disabled"
      />
      <label :for="inputName + index">{{ label }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Toggle',
  props: {
    value: {
      type: [Boolean, String, Array],
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'checkbox'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputName() {
      return `toggle_${this._uid}`
    },
    toggles() {
      if (this.type === 'radio') {
        if (this.label) return [this.label]
        return this.options
      } else {
        return [this.label]
      }
    }
  },
  methods: {
    isChecked(label) {
      if (this.type === 'radio') {
        if (Array.isArray(this.value)) {
          return this.value.indexOf(label) > -1
        }
        return this.value === label
      } else {
        return this.value
      }
    },
    inputChanged(e, label) {
      if (Array.isArray(this.value)) {
        const newValue = this.value.slice()
        const pos = newValue.indexOf(label)
        if (pos > -1 && !e.target.checked) {
          newValue.splice(pos, 1)
        } else if (pos === -1 && e.target.checked) {
          newValue.push(label)
        }
        this.$emit('input', newValue)
      } else if (typeof this.value === 'string') {
        this.$emit('input', e.target.checked ? label : '')
      } else if (typeof this.value === 'boolean') {
        this.$emit('input', e.target.checked)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.toggle {
  position: relative;
  input {
    display: none;
    &:checked + label {
      font-weight: 500;
      &::before {
        background-color: #35bdd1;
      }
      &::after {
        left: 32px;
      }
    }
    &:disabled + label {
      cursor: default;
      opacity: 0.5;
    }
  }
  label {
    font-size: 16px;
    font-weight: 300;
    line-height: 24px;
    cursor: pointer;
    padding-left: 65px;
    color: #0b0f4d;
    font: SemiBold 16px/21px 'Omnes';
    &::before {
      content: '';
      background-color: #cbd1d6;
      border-radius: 12px;
      position: absolute;
      top: 0;
      left: 0;
      width: 55px;
      height: 24px;
      transition: background-color 200ms;
    }
    &::after {
      content: '';
      background-color: #fff;
      border-radius: 50%;
      position: absolute;
      top: 1px;
      left: 1px;
      width: 22px;
      height: 22px;
      transition: left 200ms;
    }
  }
}
</style>
